import { render, staticRenderFns } from "./DistributionGoalGroup.vue?vue&type=template&id=efbbacfe&"
import script from "./DistributionGoalGroup.vue?vue&type=script&lang=ts&"
export * from "./DistributionGoalGroup.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionGoalGroup.vue?vue&type=style&index=0&id=efbbacfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports